import React from 'react'
import ReactDOM from 'react-dom'
import TagManager from 'react-gtm-module'
import ChatLoader from './helpers/ChatLoader'
import App from './App'

import './index.css'
import 'react-toastify/dist/ReactToastify.css'
import { HelmetProvider } from 'react-helmet-async'

const tagManagerArgs = {
  gtmId: process.env.REACT_APP_GTM_ID,
  auth: process.env.REACT_APP_GTM_AUTH,
  preview: process.env.REACT_APP_GTM_PREVIEW,
}

TagManager.initialize(tagManagerArgs)

const _isMaggiorTutela = window.location.search.indexOf('maggiortutela') >= 0
if (!_isMaggiorTutela) {
  new ChatLoader(
    process.env.REACT_APP_CHAT_BASE_URL,
    process.env.REACT_APP_CHAT_ENV,
    process.env.REACT_APP_CHAT_REMOTE_VERSION
  )
}

ReactDOM.render(
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>,
  document.getElementById('root')
)
